import { AccountType } from '@seapoint/server/enums';
import { AccountBankingTypeView, AccountView } from '../../types/entity-types';

export const isBankingAccount = (account: AccountView): account is AccountBankingTypeView => {
  return account.type === AccountType.BANKING;
};
